import { Component, OnInit } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  constructor(
    private readonly router: Router,
    public readonly navServices: NavService
  ) {
    this.router.events.subscribe(() => {
      this.navServices.mainMenuToggle = false;
    });
  }

  get menuItems(): Menu[] {
    return this.navServices.MENUITEMS;
  }

  ngOnInit(): void {
  }

  mainMenuToggle(): void {
    this.navServices.mainMenuToggle = !this.navServices.mainMenuToggle;
  }

  closeMenu(event: Event): void {
    event.stopPropagation();
    this.navServices.mainMenuToggle = false;
  }

  // Click Toggle menu (Mobile)
  toggletNavActive(item) {
    item.active = !item.active;
  }

}
